<template>
    <router-link class="plex-link" :to="to" @click="$emit('click')">
        <div class="plex-card md-ripple">

            <img class="image" :src="imageUrl" @click="$emit('click')"/>
            <p :title="title" @click="$emit('click')" class="md-body-2 title text">{{title}}</p>
            <p :title="caption" @click="$emit('click')" v-if="caption !== ''" class="caption text">{{caption}}</p>
            <p @click="$emit('click')" v-if="bytes !== 0" class="text title">{{toBytes(bytes)}}</p>
        </div>
    </router-link>
</template>

<script>
    import ServerApi from "../js/ServerApi";
    import Utils from "../js/Utils";

    export default {
        name: "PlexCard",
        props: {
            image: String,
            title: String,
            to: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: '',
            },
            bytes: {
                type: Number,
                default: 0,
            }
        },
        methods: {
            toBytes(b) {
                return Utils.bytesToReadable(b);
            },
        },
        computed: {
            imageUrl() {
                if (this.image)
                    return ServerApi.imageUrl(this.image);
                return 'img/notfound.png';
            }
        }
    }
</script>

<style scoped>
    .plex-link {
        box-shadow: 0 5px 20px -5px rgba(0, 0, 0, 0.5);
        border-radius: 5px;
    }

    .plex-card {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    .image {
        border-radius: 5px 5px 0 0;
    }

    .title {
        color: rgba(0, 0, 0, 0.6);
        font-weight: bold;
    }

    .text {
        padding: 8px 5px;
        margin: 2px;
        text-align: center;
        max-width: 100%;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>